import React, {Component} from 'react';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import FilterByLineGroup from 'components/molecules/filter-by-line-group';
import ExposureMode from 'components/molecules/exposure-mode';
import UserPointsType from 'components/molecules/user-points-type';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import SelectOpposingPlayers from 'components/molecules/select-opposing-players';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import OpposingGoalie from 'components/molecules/opposing-goalie';
import NHLPlayerNameStack from 'components/organisms/nhl-player-name-stacking';
import NHLNonControlledStack from 'components/organisms/nhl-non-controlled-stacking';
import FlexMaxExpPositions from 'components/organisms/flex-max-exp-positions';
import OptimizeButton from 'components/molecules/optimize-button';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import OptimizeOpener from 'components/molecules/optimize-opener';
import NHLTeamStacking from 'components/organisms/nhl-team-stacking';
import NHLLegacyTeamStacking from 'components/organisms/nhl-legacy-team-stacking';
import SelectLineupResolver from 'components/molecules/select-lineup-resolver';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';

class PlayersDashboard extends Component {
    render() {
        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary useDragging={true} />
                            <FilterByPoints useDragging={true} />
                            <SelectSalaryCap useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType />
                            <UniquePlayersQuantity />
                            <SelectLineupResolver />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <FlexMaxExpPositions label={'Util positions'} />
                        </div>
                        <div className="filters-cell">
                            <FilterByLineGroup />
                        </div>
                        <div className="filters-cell">
                            <OpposingGoalie />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'nhl'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <NHLTeamStacking />
                <NHLLegacyTeamStacking />
                <NHLPlayerNameStack />
                {/*<NHLNonControlledStack/> hidden, candidate for removing DFSA-791 */}
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

export {PlayersDashboard};
